// Configuración de variables de entorn
export const NODE_ENV = process.env.NODE_ENV!;
export const URL_API = process.env.URL_API!;
export const DOMINE_KIUBIX = process.env.DOMINE_KIUBIX!;
export const TIME_CLOSE_TOAST = +process.env.TIME_CLOSE_TOAST! * 1000;
export const URL_WHMCS = process.env.URL_WHMCS!;